export default __webpack_public_path__ + "static/media/i-subject.8e61bdcb.png";